declare namespace Slick {
    interface Column {
        grouping?: false | GroupInfo<any>;
    }
}

namespace Slick.Plugins {
    
    export interface DraggableGroupingOptions {
        deleteIconCssClass?: string;
        deleteIconImage?: string;
        dropPlaceHolderText?: string;
        getGroupingFor?: (column: Column) => GroupInfo<any>;
        getAllColumns?: () => Slick.Column[];
    }

    /**
     * Based on plugin at https://github.com/muthukumarse/Slickgrid
     */
    export class DraggableGrouping {
        
        private grid: Grid;
        private gridUid: string;
        private dataView: RemoteView<any>;
        private dropbox: JQuery;
        private dropboxPlaceholder: JQuery;
        private expandAll: JQuery;
        private collapseAll: JQuery;
        private options: DraggableGroupingOptions;
        private columnsGroupBy: Slick.Column[];
        public onGroupChanged = new Slick.Event();

        constructor(options?: DraggableGroupingOptions) {
            var defaults: DraggableGroupingOptions = {
            };

            this.options = $.extend(true, {}, defaults, options);
        }

        public init(grid: Slick.Grid) {
            this.grid = grid;
            this.gridUid = grid['getUID']();
      
            this.dropbox = $(grid['getGroupingPanel']());
            var dropPlaceHolderText = this.options.dropPlaceHolderText || 
                Q.tryGetText("Site.DraggableGroupingMixin.DropPlaceholder") ||
                "Drag a column header here to group by that column";

            this.dropbox.html("<div class='slick-dropped-placeholder'>" + 
                dropPlaceHolderText + "</div>" + 
                    `<div class="slick-group-expand-all" title="${
                        Q.tryGetText("Site.DraggableGrupingMixin.ExpandAllButton") || "Expand All"}" style="display:none"></div>` + 
                    `<div class="slick-group-collapse-all" title="${
                        Q.tryGetText("Site.DraggableGrupingMixin.CollapseAllButton") || "Collapse All"}" style="display:none"></div>`);

            this.dropboxPlaceholder = this.dropbox.find(".slick-dropped-placeholder");
            this.expandAll = this.dropbox.find(".slick-group-expand-all");
            this.collapseAll = this.dropbox.find(".slick-group-collapse-all");
            this.setupColumnDropbox();

            var cols = this.getColumns();
            for (var i = 0; i < cols.length; i++) {
                var col = cols[i];
                grid['updateColumnHeader'](col.id);
            }

            this.columnsGroupBy = [];
        }

        private getColumns(): Slick.Column[] {
            return (this.options.getAllColumns && this.options.getAllColumns()) || 
                this.grid.getColumns();
        }

        public destroy() {
            this.onGroupChanged.clear();
        }

        private setupColumnDropbox() {
            var _self = this;
            this.dropbox.droppable({
                activeClass: "ui-state-default",
                hoverClass: "ui-state-hover",
                accept: ":not(.ui-sortable-helper)",
                deactivate: (event, ui) => {
                    this.dropbox.removeClass("slick-header-column-denied");
                },
                drop: function(event, ui) {
                    _self.handleGroupByDrop(this, 
                        ui.draggable.attr('id').replace(_self.gridUid, ""));
                },
                over: (event, ui) => {
                    var id = (ui.draggable).attr('id').replace(this.gridUid, "");
                    this.getColumns().forEach((e, i, a) => {
                        if (e.id == id) {
                            if (e.grouping !== false) {
                                this.dropbox.addClass("slick-header-column-denied");
                            }
                        }
                    });
                }
            });

            this.dropbox.sortable({
                items: "div.slick-dropped-grouping",
                cursor: "default",
                tolerance: "pointer",
                helper: "clone",
                update: (event, ui) => {
                    var sortArray = $(event.target).sortable('toArray', {
                        attribute: 'data-id'
                    }),
                    newGroupingOrder = [];
                    for (var i = 0, l = sortArray.length; i < l; i++) {
                        for (var a = 0, b = this.columnsGroupBy.length; a < b; a++) {
                            if (this.columnsGroupBy[a].id == sortArray[i]) {
                                newGroupingOrder.push(this.columnsGroupBy[a]);
                                break;
                            }
                        }
                    }
                    this.columnsGroupBy = newGroupingOrder;
                    this.updateGroupBy();
                }
            });

            this.expandAll.on('click', (e) => {
                (this.grid.getData() as any).expandAllGroups();
            });

            this.collapseAll.on('click', (e) => {
                (this.grid.getData() as any).collapseAllGroups();
            });
        }

        public getGroupingFor(column: Column): GroupInfo<any> {
            var g = null;

            if (this.options.getGroupingFor) {
                g = this.options.getGroupingFor(column);
            }
                    
            if (g === false)
                return g;

            return $.extend({
                getter: column.field || column.id,
                formatter: function (g: Group<any>) {
                    var text;
                    if (column.formatter) {
                        try {
                            var item = new Slick.NonDataRow();
                            item["__grp"] = g;
                            item[column.field] = g.value;
                            text = column.formatter(-1, -1, g.value, column, item);
                        }
                        catch (e) {
                            text = Q.htmlEncode(g.value);
                        }
                    }
                    else
                        text = Q.htmlEncode(g.value);

                    return '<span class="s-group-name">' +
                        (column.name || column.field || column.id) + ': </span>' + 
                            text + ' <span class="s-group-count">(' + 
                            (g.count || 0).toString() + ")</span>";
                },
                collapsed: true
            }, g);
        }

        handleGroupByDrop(container: JQuery, columnid: string) {
            var columnAllowed = true;
            this.columnsGroupBy.forEach(function(clmn, i, a) {
                if (clmn.id == columnid) {
                  columnAllowed = false;
                }
            });

            var gridColumns = this.getColumns();

            if (!columnAllowed)
                return;

            gridColumns.forEach((col, i, a) => {
                if (col.id !== columnid || col.grouping === false)
                    return;

                if (col.grouping == null || $.isEmptyObject(col.grouping)) {
                    col.grouping = this.getGroupingFor(col);
                    if (col.grouping === false)
                        return;
                }

                var entry = $("<div id='" + this.gridUid + 
                    col.id + "_entry' data-id='" + col.id + 
                    "' class='slick-dropped-grouping'>");
                      
                var groupText = $("<div style='display: inline-flex'>" + 
                    col.name + "</div>")

                groupText.appendTo(entry);
                      
                var groupRemoveIcon = $("<div class='slick-groupby-remove'></div>");
                if (this.options.deleteIconCssClass) 
                    groupRemoveIcon.addClass(this.options.deleteIconCssClass);

                if (this.options.deleteIconImage) 
                    groupRemoveIcon.css("background", "url(" + this.options.deleteIconImage + ") no-repeat center right");

                if (!this.options.deleteIconCssClass && !this.options.deleteIconImage) 
                    groupRemoveIcon.addClass('slick-groupby-remove-image');

                groupRemoveIcon.appendTo(entry);

                $("</div>").appendTo(entry);
                entry.appendTo(container);
                      
                this.addColumnGroupBy(col);
                groupRemoveIcon.one('click', () => this.removeGroupBy(col.id, entry));
            });

            this.grid.invalidate();
        }

        private addColumnGroupBy(column: Column) {
            this.columnsGroupBy.push(column);
            this.updateGroupBy();
        }

        public setDroppedGroups(idList: string[]) {
            if (!idList || !idList.length) {
                this.columnsGroupBy = [];
                this.dropbox.find(".slick-dropped-grouping").remove();
            }
            else {
                for (var i = 0; i < idList.length; i++) {
                    this.handleGroupByDrop(this.dropbox, idList[i]);
                }
            }

            this.updateInterface();

        }

        private removeGroupBy(id: string, entry: JQuery) {
            entry.remove();
            var gridColumns = this.getColumns();

            var idx;
            while ((idx = Q.indexOf(this.columnsGroupBy, x => x.id == id)) >= 0)
                this.columnsGroupBy.splice(idx, 1);
            
            this.updateGroupBy();
        }

        private updateInterface() {
            var hasGrouping = !!(this.columnsGroupBy && this.columnsGroupBy.length);
            this.collapseAll.toggle(hasGrouping);
            this.expandAll.toggle(hasGrouping);
            this.dropboxPlaceholder.toggle(!hasGrouping);
        }

        private updateGroupBy() {
            this.updateInterface();

            if (this.columnsGroupBy.length == 0) {
                (this.grid.getData() as any).setGrouping([]);
                this.onGroupChanged.notify({ groupColumns: [] });
                this.grid.invalidate();
                return;
            }
      
            var groupingArray: any[] = [];
            this.columnsGroupBy.forEach(function(element, index, array) {
                groupingArray.push(element.grouping);
            });

            (this.grid.getData() as any).setGrouping(groupingArray);
            this.grid.invalidate();
            this.onGroupChanged.notify({ groupColumns: groupingArray})
        }

        public static setupColumnReorder(grid: Slick.Grid, $headers: JQuery, 
            setupColumnResize: () => void, trigger: (ev: any, p: any) => void) {
            $headers.filter(":ui-sortable").sortable("destroy");
            var $headerDraggableGroupBy = $(grid['getGroupingPanel']());
            var columns = grid.getColumns();
            var uid = grid['getUID']();
            $headers.sortable({
                distance: 3,
                cursor: "default",
                tolerance: "intersection",
                helper: "clone",
                placeholder: "slick-sortable-placeholder ui-state-default slick-header-column",
                forcePlaceholderSize: true,
                appendTo: "body",
                start: function(e, ui) {
                    $(ui.helper).addClass("slick-header-column-active");
                },
                beforeStop: function(e, ui) {
                    $(ui.helper).removeClass("slick-header-column-active");
                    var hasDroppedColumn = $headerDraggableGroupBy
                        .find(".slick-dropped-grouping").length;
                    if (hasDroppedColumn > 0){
                        $headerDraggableGroupBy.find(".slick-dropped-placeholder").hide();
                        $headerDraggableGroupBy.find(".slick-dropped-grouping").show();  
                    }            
                },
                stop: function(e) {
                    if (!grid['getEditorLock']().commitCurrentEdit()) {
                        $(this).sortable("cancel");
                        return;
                    }
            
                    var reorderedIds = $headers.sortable("toArray");
                    var reorderedColumns = [];
                    for (var i = 0; i < reorderedIds.length; i++) {
                        reorderedColumns.push(columns[grid.getColumnIndex(
                            reorderedIds[i].replace(uid, ""))]);
                    }
                    grid.setColumns(reorderedColumns);
                    trigger(grid.onColumnsReordered, {});
                    e.stopPropagation();
                    setupColumnResize();
                }
            });
        }
    }
}